export const defaultSettings = (element) => {
    const id = `item-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

    const type = element.split("-")[0];
    const label = element.split("-")[1];

    const base = {
        id: id,
        type: type
    }

    switch (type) {
        case "input":
            base.settings = {
                inputType: label,
                title: "",
                description: "",
                variables: "",
                required: false,
                new: true
            }

            if (label === "select")
                base.settings.options = [];
            else if (label === "radio")
                base.settings.selectedRadioGroup = {};

            break;
        case "area":
            base.settings = {
                areaType: element,
            }
            break;
        case "text":
            base.settings = {
                textSize: label,
                alignType: "center",
                verticalType: "top",
                textColor: "#000000",
                fontFormats: [],
                listType: "plain",
                textInput: "",
                new: true
            }
            break;
    }

    return base;
}